import { Minus, TrendDown01, TrendUp01 } from "@untitledui/icons";
import { cx } from "@/utils/cx";
import type { VehicleRankingItem } from "../types";
import { formatPercent } from "../utils";

type VehicleExpenseTrendProps = {
	data: VehicleRankingItem;
};
export const VehicleExpenseTrend = ({ data }: VehicleExpenseTrendProps) => {
	const previousMonthTrendIsPositive = data.percentVsPreviousMonth > 0;
	const fleetAverageTrendIsPositive = data.percentVsFleetAverage > 0;
	const previousMonthTrendIsZero =
		data.percentVsPreviousMonth === 0 || data.percentVsPreviousMonth === null;

	const PreviousMonthTrendIcon = previousMonthTrendIsPositive
		? TrendUp01
		: TrendDown01;

	return (
		<div className="mt-1 flex flex-wrap gap-4 text-sm">
			<div className="flex items-center gap-1">
				<span className="text-tertiary text-xs leading-4">vs mês ant.</span>
				{previousMonthTrendIsZero ? (
					<Minus aria-hidden className="size-3 text-gray-500" />
				) : (
					<PreviousMonthTrendIcon
						aria-hidden
						className={cx(
							"size-3.5",
							previousMonthTrendIsPositive ? "text-[#F04438]" : "text-[#027A48]"
						)}
					/>
				)}
				<span
					className={cx(
						"font-semibold text-xs leading-4",
						previousMonthTrendIsPositive ? "text-[#F04438]" : "text-[#027A48]",
						!!previousMonthTrendIsZero && "text-gray-500"
					)}
				>
					{formatPercent(data.percentVsPreviousMonth)}
				</span>
			</div>
			<div className="flex items-center gap-1">
				<span className="text-tertiary text-xs leading-4">vs média</span>
				<span
					className={cx(
						"font-semibold text-xs leading-4",
						fleetAverageTrendIsPositive ? "text-[#F04438]" : "text-tertiary"
					)}
				>
					{formatPercent(data.percentVsFleetAverage)}
				</span>
			</div>
		</div>
	);
};
